import { Link } from "react-router-dom";
import Button from "../components/Button";
import Section from "../components/Section";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable" noindex />
      <Section
      eyebrow="Erreur 404"
      title="Cette page n'existe pas"
      description="Le lien que vous avez suivi est introuvable."
    >
        <Link to="/">
          <Button variant="primary">Retour à l'accueil</Button>
        </Link>
      </Section>
    </>
  );
}
